import $ from 'jquery'
import Swiper from "../util/swiper/swiper";

export default {
    init() {
        // JavaScript to be fired on the home page
    },
    finalize() {
        let arrButtons = $('.switch-btn'),
            arrTables = $('.switch-table');

        function switchingTabs(arrButtons, arrTables) {
            return function () {
                let context = $(this)[0];
                for (let i = 0; i < arrButtons.length; i++) {
                    if (arrButtons[i] !== context) {
                        $(arrButtons[i]).removeClass('switch-btn-active');
                        $(arrTables[i]).removeClass('switch-table-active');
                    } else {
                        $(arrButtons[i]).addClass('switch-btn-active');
                        $(arrTables[i]).addClass('switch-table-active');
                    }
                }
            };
        }

        for (let i = 0; i < arrButtons.length; i++) {
            $(arrButtons[i]).on('click', switchingTabs(arrButtons, arrTables));
        }

        let splashSwiperMain = new Swiper('#splashSwiperMain', {
            speed: 1000,
            loop: true,
            autoplay: {
                delay: 5000,
            },
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
        });
    }
};



// WEBPACK FOOTER //
// ./scripts/routes/pageTemplateRetailBanking.js